import { userAtom } from '@states/Atoms';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';
import ShowForm from './ShowForm';
import SubmitForm from './SubmitForm';

type Props = {
    afterSbumit: any;
};
type FormData = {
    swOpenRequestId: any,
    memoContent: string,
    createUser: string,
    timestamp: number,
};
type InformationType = {
    lastSubmitTime: number,
};

const information: InformationType = {
    lastSubmitTime: 0
};
const formData: FormData = {
    swOpenRequestId: '',
    memoContent: '',
    createUser: '',
    timestamp: 0
};


const MemoForm = (props: Props) => {
    const { afterSbumit } = props;
    const id: any = useParams().id;
    const userInformation: any = useRecoilValue(userAtom.infomationState);
    const [ submitFlag, setSubmitFlag ] = useState(false);

    const onSubmitStart = (data: FormData) => {
        const lastSubmitTime = new Date().getTime();
        if (information.lastSubmitTime !== lastSubmitTime) {
            formData.memoContent = data.memoContent;
            formData.timestamp = new Date().getTime();
            information.lastSubmitTime = lastSubmitTime;
            setSubmitFlag(true);
        }
    };
    const onSubmitComplete = () => {
        setSubmitFlag(false);
        afterSbumit();
    };
    formData.swOpenRequestId = id;
    formData.createUser = userInformation.name;

    return (
        <FormWrapperWithStyled>
            {!submitFlag ?
                <ShowForm onSubmitStart={onSubmitStart} />
            :
                <SubmitForm onSubmitComplete={onSubmitComplete} formData={formData} />
            }
        </FormWrapperWithStyled>
    );
};

const FormWrapperWithStyled = styled.div`
    margin: 5px 0 0;
`

export default MemoForm;